/** Enum for a type of line item in a price book */
export enum PbProductType {
	Disposition = 'Disposition',
	Package = 'Package',
	Service = 'Service',
	Transportation = 'Transportation',
	Merchandise = 'Merchandise',
	CashAdvance = 'CashAdvance',
	FamilyTravel = 'FamilyTravel',
	Cemetery = 'Cemetery',
	Afterward = 'Afterward',
	Oap = 'oap',
	Other = 'Other',
	Everplans = 'Everplans',
}
